import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import SEO from './components/SEO/SEO';
import StructuredData from './components/SEO/StructuredData';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ServicesPage from './pages/Services';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import TestimonialsPage from './pages/Testimonials';
import ProductsPage from './pages/Products';
import './styles/variables.css';
import './styles/global.css';
import './styles/waves.css';
import './App.css';

/**
 * Composant principal App - Gère le routing et la structure globale
 * Utilise React Router pour la navigation entre les pages
 */
function App() {
  return (
    <Router>
      {/* Composant pour scroller automatiquement en haut lors du changement de page */}
      <ScrollToTop />
      
      <div className="App">
        {/* Structured Data pour le SEO */}
        <StructuredData />
        
        {/* Header fixe avec navigation */}
        <Header />
        
        {/* Contenu principal avec routing */}
        <main className="main-content">
          <Routes>
            <Route 
              path="/" 
              element={
                <>
                  <SEO 
                    title="WOTE - Au delà de l'imagination! | Développement, Formation & Produits Tech"
                    description="WOTE accompagne étudiants, particuliers et entreprises : développement web et mobile, formation, conseil IT et produits comme BaDepenses. Startup tech à Kinshasa, RDC."
                    keywords="WOTE, développement web, applications mobiles, formation informatique, conseil IT, BaDepenses, startup Kinshasa, RDC, TFE, TFC"
                    image="https://wotes.org/logo.png"
                  />
                  <Home />
                </>
              } 
            />
            <Route 
              path="/services" 
              element={
                <>
                  <SEO 
                    title="Nos Services - WOTE | Développement, Formation & Conseil IT"
                    description="Services WOTE : développement web et mobile, accompagnement de projets (TFE, entreprises), formation technique et conseil stratégique à Kinshasa."
                    keywords="services WOTE, développement web, accompagnement projets, formation informatique, conseil IT, Kinshasa"
                    image="https://wotes.org/logo.png"
                  />
                  <ServicesPage />
                </>
              } 
            />
            <Route 
              path="/a-propos" 
              element={
                <>
                  <SEO 
                    title="À propos de WOTE | Mission, Vision et Valeurs"
                    description="Découvrez WOTE : startup tech à Kinshasa. Mission, vision et valeurs. Accompagnement, développement et produits innovants pour l'Afrique."
                    keywords="à propos WOTE, mission WOTE, vision WOTE, valeurs WOTE, startup Kinshasa, Jonathan KONDE"
                    image="https://wotes.org/moi.png"
                  />
                  <About />
                </>
              } 
            />
            <Route 
              path="/portfolio" 
              element={
                <>
                  <SEO 
                    title="Portfolio - Nos Réalisations | Wote"
                    description="Découvrez nos projets réalisés : applications web, applications mobiles, systèmes de gestion, projets académiques et solutions IT sur mesure."
                    keywords="portfolio Wote, projets réalisés, applications web, applications mobiles, projets académiques"
                    image="https://wotes.org/logo.png"
                  />
                  <Portfolio />
                </>
              } 
            />
            <Route 
              path="/temoignages" 
              element={
                <>
                  <SEO 
                    title="Témoignages Clients - WOTE"
                    description="Découvrez ce que nos clients disent de nos services. Témoignages d'étudiants, entrepreneurs et entreprises satisfaits."
                    keywords="témoignages WOTE, avis clients, clients satisfaits"
                    image="https://wotes.org/logo.png"
                  />
                  <TestimonialsPage />
                </>
              } 
            />
            <Route 
              path="/produits" 
              element={
                <>
                  <SEO 
                    title="Nos Produits - WOTE | BaDepenses et solutions maison"
                    description="Découvrez les produits WOTE : BaDepenses pour gérer vos dépenses au quotidien. Solutions conçues pour le grand public."
                    keywords="produits WOTE, BaDepenses, gestion dépenses, application WOTE, startup Kinshasa"
                    image="https://wotes.org/logo.png"
                  />
                  <ProductsPage />
                </>
              } 
            />
          </Routes>
        </main>
        
        {/* Footer avec informations et bouton WhatsApp */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
